export default __webpack_public_path__ + "static/media/actions-fantom.798ab3aa.svg";